/**
 * userEntityAssignments constants
 */
export const USER_ENTITY_ASSIGNMENTS_SET = 'USER_ENTITY_ASSIGNMENTS_SET';
export const USER_ENTITY_ASSIGNMENTS_MERGE = 'USER_ENTITY_ASSIGNMENTS_MERGE';
